/**
 * MeleeEvents - the melee-swing counterpart to GameEvents.js's projectileSpawned
 * handling: tells every OTHER client that a swing happened, so their weapon
 * sprite plays the same idle/firing swap a gunshot would (PixiEntityRenderer
 * already drives that purely off playerLastShotTime - no new rendering code).
 */
const MeleeEvents = {
  /**
   * Register melee-related event handlers
   * @param {Socket} socket - Socket.io socket instance
   * @param {GameState} gameState - Game state container
   */
  register(socket, gameState) {
    socket.on('meleeSwung', (data) => {
      if (!data?.playerId) return;
      if (data.playerId === gameState.localId) return; // local swing already predicted in onShoot
      gameState.playerLastShotTime.set(data.playerId, performance.now());
    });
  }
};

// Export for use in other modules
// For now, MeleeEvents is a global object loaded via script tag

export { MeleeEvents };
